import { Badge } from "@elaniintc/goes-design-system";
import { useGetUser } from "@/queries/users/users.api";
import dayjs from "dayjs";

interface ResolutionCommentProps {
  status: "APPROVED" | "DENIED";
  comment: string;
  createdAt: string;
  createdBy?: string;
}

const UserName = ({ userId }: { userId: string }) => {
  const { data: user, isLoading } = useGetUser(userId);

  if (isLoading) return <span className="text-body-quiet">...</span>;

  const name = user?.name
    ? `${user.name} ${user.last_name ?? ""}`.trim()
    : "Desconocido";

  return <span className="text-action">{name}</span>;
};

const ResolutionComment = ({
  status,
  comment,
  createdAt,
  createdBy,
}: ResolutionCommentProps) => {
  const isRejected = status === "DENIED";

  return (
    <div className="w-full p-2 bg-neutral-object-accent-silent rounded-lg border border-neutral flex flex-col gap-1">
      <div className="flex items-center gap-2">
        <Badge
          variant={isRejected ? "danger" : "success"}
          size="xs"
          shape="square"
        >
          {isRejected ? "Rechazado" : "Aprobado"}
        </Badge>
      </div>
      <p className="text-body leading-7">{comment}</p>
      <div className="flex items-center gap-1 text-sm">
        <span className="text-body-quiet">
          {dayjs(createdAt).format("D [de] MMMM, YYYY")} por
        </span>
        {createdBy ? (
          <UserName userId={createdBy} />
        ) : (
          <span className="text-body-quiet">Desconocido</span>
        )}
      </div>
    </div>
  );
};

export default ResolutionComment;
